// Markup copied from the old "no recent backup" banner, original/src/App.tsx:25726-25752
// (container, icon and text classes). The two buttons ("تصدير الآن", dismiss) are removed:
// D-223 requires the preview notice on every screen, D-152 moves backup state elsewhere.
// The wipe-date chip keeps the old button box (`px-4 py-1.5 … text-xs`, App.tsx:25740) so the
// strip stays 53 px high and nothing below it shifts (tests/visual DEVIATIONS.md V-02).
import { AlertTriangle } from 'lucide-react';
import { useT } from '../i18n-context.js';

export interface PreviewBannerData {
  readonly text: string;
  readonly wipeDate: string;
}

export function PreviewBanner({ banner }: { banner: PreviewBannerData }) {
  const t = useT();
  return (
    <div
      data-testid="preview-banner"
      className="bg-amber-500/10 border-b border-amber-500/20 px-8 py-3 flex items-center justify-between gap-4 overflow-hidden"
    >
      <div className="flex items-center gap-3 text-amber-600 dark:text-amber-400">
        <AlertTriangle size={20} className="shrink-0" />
        <p className="text-sm font-black uppercase tracking-tight">
          {banner.text}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <span className="px-4 py-1.5 rounded-xl text-xs font-black text-amber-600 dark:text-amber-400 font-mono">
          {t('preview.wipe_date', { date: banner.wipeDate })}
        </span>
      </div>
    </div>
  );
}
